import { useEffect, useState } from 'react'
import activityApi from '@/apis/activity'
import {
  AuthorizePresentation,
  resolveAuthorizePresentation,
} from '@/pages/application-flow-skins/theme/authorize-presentation'

interface ChannelDetail {

  /** 渠道模板是授权页 v1/v2 与主题的唯一选择依据。 */
  channelTemplate?: unknown
}

interface PresentationState {

  /** 当前展示结果对应的渠道码，避免旧渠道异步结果覆盖新渠道。 */
  adChannelCode: string

  /** 该渠道码的解析状态：加载中、有效 v2 主题或旧授权页。 */
  presentation: AuthorizePresentation | null | undefined
}

/**
 * useAuthorizePresentation — 为旧授权业务容器加载新版展示配置。
 * Hook 只提供展示版本与主题，绝不读取或改变旧授权的协议、埋点、Storage、倒计时、请求与跳转状态。
 * @param {string} adChannelCode 旧容器已解析的渠道码
 * @returns {AuthorizePresentation | null | undefined} 加载中的 undefined、有效 v2 配置或沿用旧授权页的 null
 */
const useAuthorizePresentation = (
  adChannelCode: string,
): AuthorizePresentation | null | undefined => {
  const [state, setState] = useState<PresentationState>(() => ({
    adChannelCode,
    presentation: adChannelCode ? undefined : null,
  }))

  useEffect(() => {
    if (!adChannelCode) {
      setState({
        adChannelCode,
        presentation: null,
      })
      return undefined
    }

    let active = true
    setState({
      adChannelCode,
      presentation: undefined,
    })
    const loadPresentation = async() => {
      try {
        const detail = await activityApi.getChannelCodeDetail(adChannelCode) as ChannelDetail
        if (active) {
          setState({
            adChannelCode,
            presentation: resolveAuthorizePresentation(detail),
          })
        }
      } catch (error) {
        // 展示配置异常时保持已验证的旧授权页，不能改变授权链路或临时推断主题。
        if (active) {
          setState({
            adChannelCode,
            presentation: null,
          })
        }
      }
    }

    loadPresentation()
    return () => {
      active = false
    }
  }, [adChannelCode])

  if (!adChannelCode) {
    return null
  }

  return state.adChannelCode === adChannelCode ? state.presentation : undefined
}

export default useAuthorizePresentation
